import { CurrentUserService } from '../../shared/services/current-user.service';
import { ErrorService } from './../../shared/services/error.service';

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';

import { AccountSettings } from '../../models/account-settings';
import { UserProfile } from '../../models/program/user-profile';
import { Program } from '../../models/program/program';
import { PermissionsService } from '../../shared/services/permissions.service';
import { ApiKey } from '../../models/api-key';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.less']
})

export class AccountSettingsComponent implements OnInit {
  @Input() user: AccountSettings;
  @Output() recall: EventEmitter<boolean> = new EventEmitter<boolean>();
  public userInfo: any;
  public avatar: string;
  public settings: FormGroup;
  public settingsProfile: FormArray;
  public pass: string;
  public confirm: string;
  public passWarn = false;
  public saving: boolean;
  public saved: boolean;
  public errors: string[];
  public tab = 'profile'; // which of the tabs is active
  public showApiKeyTab: boolean = false;
  public apiKey: ApiKey;
  public justGeneratedToken: boolean = false;

  constructor(
    private currentUserService: CurrentUserService,
    private _fb: FormBuilder,
    private errorService: ErrorService,
    private permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.settings = this._fb.group({
      first_name: [this.user.first_name, <any>Validators.required],
      last_name: [this.user.last_name, <any>Validators.required],
      avatar: [this.user.avatar],
      disable_all_emails: [this.user.disable_all_emails],
      profile: this._fb.array([]),
      password: [null, [<any>Validators.required, <any>Validators.minLength(1)]], // default to something invalid
    });
    this.settingsProfile = this.settings.get('profile') as FormArray;

    this.settings.controls['password'].disable(); // disable so it doesn't get validated or submitted

    this.initProfiles(this.user.profile);

    console.log(this.user, this.settings.value);

    this.permissionsService.checkPermission("manageOwnAdminApiKey").subscribe((hasPermission: boolean) => {
      this.showApiKeyTab = hasPermission;

      if (hasPermission) {
        this.getApiKey();
      }
    })
  }

  /**
   * Public Methods
   */

  public save(model: any, isValid: boolean): void {
    console.log(model, isValid);
    this.saving = true;
    this.saved = false;
    this.errors = [];
    this.currentUserService.saveAccountSettings(model)
                    .subscribe(res => {
                      this.saving = false;
                      this.saved = true;
                      this.recall.emit(true);
                    }, errorResponse => {
                      this.errors = this.errorService.messages(errorResponse);
                      this.saving = false;
                    });
  }

  public checkPass(pass: string, confirm: string): void {
    const passwordSetting = this.settings.controls['password'];
    if (confirm === pass) {
      this.passWarn = false;
      passwordSetting.patchValue(pass);
    } else {
      this.passWarn = true;
      passwordSetting.patchValue(null); // something that will fail the client side validation
    }

    if (pass || confirm) {
      passwordSetting.enable();
    } else {
      passwordSetting.disable(); // ignore and don't send if empty
    }
  }

  public createApiKey(): void {
    this.currentUserService.createApiKey().subscribe((apiKey: ApiKey) => {
      this.justGeneratedToken = true;
      this.apiKey = apiKey;
    })
  }

  public deleteApiKey(): void {
    this.currentUserService.deleteApiKey().subscribe(() => {
      this.apiKey = null;
    })
  }

  /**
   * Private Methods
   */

  private initProfiles(profiles: UserProfile[]): any {
    const control: FormArray = <FormArray>this.settings.controls['profile'];
    profiles.forEach(profile => control.push(this.profileForm(profile)));
  }

  private getApiKey(): void {
    this.justGeneratedToken = false;
    this.currentUserService.getApiKey().subscribe((apiKey) => {
      this.apiKey = apiKey;
    })
  }

  private profileForm(profile: { field_id: number, value: string }): FormGroup {
    let profileForm: FormGroup = this._fb.group({
      field_id: [null],
      value: [null]
    });
    profileForm.patchValue(profile);
    return profileForm;
  }

  public changeTab(event: Event, tabName: string) {
    this.tab = tabName;
    event.preventDefault();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-user/account-settings/account-settings.component.ts